import PropTypes from 'prop-types';
import {CreateUpdateEntityDialog} from '@ozgene/gp5.components.create-update-entity-dialog';
import ConsumableEditor from 'Consumables/components/ConsumableEditor';
import {saveConsumable} from 'Consumables/service/ConsumableService';

export default function UpdateCreateConsumableDialog(props) {
  const {entity, closeDialog} = props;
  const handleSave = async (consumable) => {
    const {error} = await saveConsumable(consumable);

    closeDialog();

    if (error) {
      return;
    }
  };

  return (
    <CreateUpdateEntityDialog
      entityType="Consumable"
      entity={entity}
      EditorComponent={ConsumableEditor}
      onSave={handleSave}
      onClose={closeDialog}
    />
  );
}

UpdateCreateConsumableDialog.propTypes = {
  entity: PropTypes.shape({
    name: PropTypes.string,
    productCode: PropTypes.string,
    supplier: PropTypes.string,
  }),
  closeDialog: PropTypes.func.isRequired,
};

UpdateCreateConsumableDialog.contextTypes = {
  router: PropTypes.object.isRequired,
};

UpdateCreateConsumableDialog.defaultProps = {
  entity: null,
};
